import * as v from "valibot";

import { rpcContract } from "../rpc";

export const setExclusiveUnifiedLinkRpcContract = rpcContract({
  name: "setExclusiveUnifiedLink",
  paramsSchema: v.object({
    linkId: v.optional(v.string()), // If undefined/null, removes exclusive status from all links
    influencerId: v.pipe(
      v.string("influencerId must be a string"),
      v.uuid("Invalid influencerId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
    ),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SetExclusiveUnifiedLinkParams = v.InferOutput<(typeof setExclusiveUnifiedLinkRpcContract)["paramsSchema"]>;
export type SetExclusiveUnifiedLinkResult = v.InferOutput<(typeof setExclusiveUnifiedLinkRpcContract)["resultSchema"]>;
